import { getFormattedDate } from "../../utils/date";
import { Movie } from "../../utils/types";
import "./index.css";
import LocalMovies from "@mui/icons-material/LocalMovies";
import { useMovieItem } from "./useMovieItem";
import { useNavigate, useLocation } from "react-router-dom";
import { OptionsMenu } from "../options-menu/OptionsMenu";
import PushPinIcon from "@mui/icons-material/PushPin";
import { logCTAEvent } from "../../service/analytics";

interface Props {
  movie: Movie;
}

export const MovieItem = ({ movie }: Props) => {
  const {
    showOptions,
    handleOptionsClick,
    getMovieOptions,
    onOptionClick,
    closeOptions,
    isPinned,
    isWatchListScreen,
  } = useMovieItem(movie);
  const navigate = useNavigate();
  const location = useLocation();

  const imagePath = movie.poster_path ?? movie.backdrop_path;
  const movieOptions = getMovieOptions();

  const onItemPress = () => {
    logCTAEvent("cta_click_movie_card", {
      item_id: movie.id,
      item_name: movie.title || "",
      vote_average: movie.vote_average || 0,
      release_date: movie.release_date || "",
      screen: location.pathname,
    });
    navigate("/detail/" + movie.id);
  };

  return (
    <div
      style={{
        position: "relative",
      }}
      key={movie.id}
      className="grid-item"
    >
      {imagePath ? (
        <div className="movie-poster-container" onClick={onItemPress}>
          <img
            className="image"
            src={`${process.env.REACT_APP_RAPID_IMAGE_BASE_URL}/w300/${imagePath}`}
            alt="Movie Info"
            style={{
              width: "100%",
              aspectRatio: "2/3",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      ) : (
        <div
          onClick={onItemPress}
          style={{
            width: "100%",
            aspectRatio: "2/3",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <LocalMovies
            style={{
              fontSize: 48,
              color: "#ccc",
            }}
          />
        </div>
      )}

      {(movie.vote_average > 0 || (isPinned && isWatchListScreen)) && (
        <div className="rating-badge">
          {movie.vote_average > 0 && (
            <>
              <img
                style={{
                  width: 14,
                  height: 14,
                }}
                alt="IMDB"
                src={require("../../assets/ic_imdb.png")}
              />
              <span>{movie.vote_average.toFixed(1)}</span>
            </>
          )}
          {isPinned && isWatchListScreen && (
            <PushPinIcon
              sx={{
                width: 15,
                height: 15,
                marginLeft: movie.vote_average > 0 ? "4px" : "0px",
                color: "white",
              }}
            />
          )}
        </div>
      )}

      <div
        className="bottom-view"
        onClick={onItemPress}
        style={{ cursor: "pointer" }}
      >
        <div className="movieTitle" title={movie.title}>
          {movie.title}
        </div>
        {movie?.release_date && (
          <div className="release-date">
            {getFormattedDate(movie.release_date)}
          </div>
        )}
      </div>
      <OptionsMenu
        visible={showOptions}
        onToggle={handleOptionsClick}
        options={movieOptions}
        onOptionClick={onOptionClick}
        onClose={closeOptions}
      />
    </div>
  );
};
